<template>
  <div id="login">
    <div class="box hide-scrollbars">
      <div class="info">

        <div class="info" v-if="event_loaded">
                <img class="logo" :src="event.logo_login">
        </div>
        <div class="info" v-else>
            <img class="logo main" :src="app_url + 'img/logo_new_black.png'">
        </div>

        <template v-if="inTime">

          <div class="description">{{$t('login.create_password')}}</div>

          <div class="form">

            <div id="message" v-show="message" v-html="message"></div>

            <input type="password" name="password1" v-on:focus="onfocus = true" v-on:focusout="onfocus = false"  v-model.trim="password1" :placeholder="$t('login.new_password')">
            <input type="password" name="password2" v-on:focus="onfocus = true" v-on:focusout="onfocus = false"  v-model.trim="password2" :placeholder="$t('login.repeat_password')">

            <button type="button" :style="{backgroundColor: ( event_loaded ? event.color : '' )}" @click="changePassword()">{{ $t('create_pass') }}</button>

          </div>

        </template>

        <template v-else>

          <div class="message error">{{$t('login.link_expired')}}</div>

        </template>

      </div>
    </div>

    <div @click="goIntowin" class="tech-partner" :class="{onfocus: onfocus}"></div>

  </div>
</template>

<script>
/* global isEmpty, sha256 */
import { Api } from '@/core/api.js'

import i18n from '@/i18n'
const api = new Api()

export default {
  name: 'ChangePassword',
  components: {

  },
  data () {
    return {
      password1: '',
      password2: '',
      id: '',
      time: '',
      lang: '',
      inTime: false,
      errorPassword: false,
      changedSuccess: false,
      errorChanged: false,
      message: false,
      event_selected: false,
      app_url: process.env.VUE_APP_APP_URL,
      event_loaded: false,
      onfocus: false
    }
  },
  computed: {
    event () {
      const oEvent = { ...this.$store.getters.getCurrentEvent() }
      oEvent.logo_login = (oEvent.logo && oEvent.logo.replace(/(\.\w+)$/, '_logo$1')) || ''
      return oEvent
    }
  },
  created () {
    this.onChangeRoute()
  },
  methods: {
    goIntowin () {
      window.open('http://www.intowin.io', '_blank')
    },

    onChangeRoute () {
      var lang = typeof this.$route.params.lang !== 'undefined' ? this.$route.params.lang : 'ca'
      var self = this
      this.inTime = true

      i18n.loadLanguageAsync(lang).then(function () {
        if (typeof self.$route.params.event !== 'undefined') self.event_loaded = true
      })
    },

    changePassword () {
      // remove all alerts
      this.message = false
      document.getElementById('message').classList.remove('success')
      document.getElementById('message').classList.add('error')

      // check if 2 password aren't empty
      if (!isEmpty(this.password1) && !isEmpty(this.password2)) {
        let password1 = sha256(this.password1)
        let password2 = sha256(this.password2)

        // same password => update
        if (password1 === password2) {
          var self = this

          // update password
          api.post('reset', { id: this.$route.params.user, password: password1 }).then(function (response) {
            if (response.status) {
              document.getElementById('message').classList.add('success')
              self.message = i18n.t('login.redirect')
              setTimeout(function () {
                window.location = process.env.VUE_APP_APP_URL + self.$route.params.event + '/login'
              }, 3000)
            } else {
              document.getElementById('message').classList.add('error')
            }
          })
        } else {
          // passwords are diferent, show error
          this.errorPassword = true
          document.getElementById('message').classList.add('error')
        }
      }
    }

  },
  watch: {
    event_selected: {
      handler (value) {
        var aEvents = this.$store.getters.getActiveEvents()
        this.$store.commit('setCurrentEvent', aEvents[value])
        this.event_loaded = true
      },
      deep: true
    },
    event: {
      immediate: true,
      handler (newVal) {
        if (newVal && newVal.id) {
          this.event_selected = newVal.id
          this.event_loaded = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  #container {
    padding: 0 !important;
  }

  #login {
    width: 100%;
    height: 100vh;
    margin: 0;
    padding: 25px;
    background: linear-gradient(0deg, #ddd, #FFF);
    color: $secondary-color;
    overflow: auto;

    #message {
        font-size: 12px;
    }

    .box {
        max-width: 275px;
        width: 100%;
        height: auto;
        max-height: calc(100% - 40px);
        margin: 0 auto;
        overflow: auto;
        text-align: center;

        .message.error {
            background-color: #f73f2061;
            margin: 10px 0;
            border: 2px solid #e61515;
            border-radius: 5px;
            padding: 10px;
            color: #FFF;
            font-weight: bold;
        }

        .info {
          text-align: center;

          .logo {
            display: inline-block;
            height: 150px;
            padding: 15px;

            &.main {
                height: 100px;
            }
          }

          .description {
            width: 100%;
            display: block;
            color: $main-color;
            font-size: 16px;
            text-align: center;
          }
        }
        .form  {
          margin-top: 50px;
        }

        input {
          width: 100%;
          padding: 15px;
          margin-bottom: 5px;
          border: 1px solid #444;
          outline: none;
          font-size: 11pt;
          border-radius: 3px;
          color: $main-color;
          display: block;

          &::placeholder{
            color: $main-color;
          }
        }

        button {
          width: calc(100%);
          padding: 12px;
          outline: none;
          border: none;
          cursor: pointer;
          font-size: 12pt;
          border-radius: 3px;
          text-transform: uppercase;
          transition: all 0.5s;
          background-color: #000;
          color: $secondary-color;
          margin-top: 12px;
          font-weight: bold;

          &.secondary {
            background: none;
            text-transform: initial;
            color: #999;
            font-weight: lighter;

            &:hover {
              text-decoration: underline;
            }
          }

          // &:hover {
          //   // background-color: $main-color;
          //   // color: #fff;
          // }
        }

        button + .mlanguage {
          width: calc(100% - 50px);
        }

        button + .mlanguage, .mlanguage {
          display: inline-block;
          margin-top: 12px;
          height: 40px;
        }
        .mlanguage {
          float: none;
        }

        .remember {
            font-size: 10pt;
            margin-top: 20px;
            color: $secondary-color;
            cursor: pointer;
            display: block;
            text-decoration: none;
            text-align: center;
            color: #999;
            text-decoration: underline;

            &:hover {
                text-decoration: underline;
            }
        }

        .success {
            border: 2px solid #087908;
            border-radius: 5px;
            background-color: #a0f8b6;
            color: #000;
            padding: 10px 5px;
            font-size: 16px;
            text-align: center;
            margin: 20px 0;
        }

    }

    .tech-partner {
      @include display-flex();
      @include align-items(center);
      @include justify-content(center);
      position: fixed;
      // position: fixed;
      bottom: 10px;
      left: 0;
      width: 100%;
      text-align: center;
      height: 50px;
      @include background( $image: img('intowin_partner_v2.png'), $size: 250px, $position:  center );
    }
  }

  @include media("<=desktop") {
    #login {
      overflow: hidden;

      .box .info .logo {
        height: 50px;
        padding: 6px;
        width: auto;
      }
      .box .form  {
        margin-top: 24px;
      }

        .tech-partner.onfocus {
          display: none;
      }
    }

  }

</style>
